<script setup>
import WizardSingleApplication from './Wizard/WizardSingleApplication';

defineProps({
  application1: {
    type: Object,
    default: null,
  },
  application2: {
    type: Object,
    default: null,
  },
});
</script>

<template>
  <div class="grid-2 justify-content-start mt-4 mb-4">
    <wizard-single-application
      :key="application1?.id"
      :prefilled-application="application1"
      :default-application-name="`${trans('common.application')} 1`"
      @application-selected="handleApplicationSelected(1, $event)"
      @edit-application="handleApplicationEdit"
      @remove-application="$emit('remove-application', $event)"
      @show="$emit('show', $event)"
      :id="1"
    />

    <wizard-single-application
      :key="application2?.id"
      :prefilled-application="application2"
      :default-application-name="`${trans('common.application')} 2`"
      @application-selected="handleApplicationSelected(2, $event)"
      @edit-application="handleApplicationEdit"
      @remove-application="$emit('remove-application', $event)"
      @show="$emit('show', $event)"
      :id="2"
    />
  </div>
</template>

<script>
export default {
  methods: {
    handleApplicationSelected(id, application) {
      this.$emit('application-selected', {
        id,
        application,
      });
    },

    handleApplicationEdit(application) {
      this.$emit('edit-application', application);
    },

    emitSelectedTwoApps() {
      if (this.application1 != null && this.application2 != null) {
        this.$emit('selected-two-apps', {
          application1: this.application1,
          application2: this.application2,
        });
      }
    },
  },
};
</script>
